import { render, staticRenderFns } from "./TrendingTopicLanguage.vue?vue&type=template&id=dbf86ab2&"
import script from "./TrendingTopicLanguage.vue?vue&type=script&lang=js&"
export * from "./TrendingTopicLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports